// HSL color type

export type HSLColor = {
  a: number // alpha (0-1)
  h: number // hue (0-1)
  l: number // lightness (0-1)
  s: number // saturation (0-1)
}
